// extracted by mini-css-extract-plugin
module.exports = {"container":"OtherDebts_container__14u6Q","subtitle":"OtherDebts_subtitle__3KzIF"};